import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=1ca54152&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=ts"
export * from "./LoginView.vue?vue&type=script&lang=ts"
import style0 from "./LoginView.vue?vue&type=style&index=0&id=1ca54152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca54152",
  null
  
)

export default component.exports